import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
import { IModuleByggnadsdata, IModuleVärmePrimärFjärr } from "../../types/ModuleDatas";
import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultSEKRow } from "../../types/BFL/Funktionskontroll";
import { nameof } from "../../components/Global/Utils";
import { logAndNotifyError } from "../logger";

//todo -> make class?!
export const bfv_J10 = (): IBFModule => {
  const bfName = BFLType.BFV_J10;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    const moduleData: IModuleVärmePrimärFjärr = module.data;
    let funktionsKontrollerSEK: IKontrollResultSEKRow[] = [];
    let funktionsKontroller: IKontrollResultRow[] = [];
    const bH = bflHelper.bflHelper();
    const dbg: any = {};

    try {
      const byggnadsDataData: IModuleByggnadsdata | undefined = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
      // const modPreviousFjärrVärme = roundHandler.getLastFinishedRound()?.data.modules.find((m) => m.id === module.id);

      const mätvärdeM3 = moduleData.mätvärdeM3;
      const mätvärdeMWh = moduleData.mätvärdeMWh;
      // const mätvärdeM3Ack = modPreviousFjärrVärme?.data[nameof<IModuleVärmePrimärFjärr>("mätvärdeM3")] ?? 0;
      // const mätvärdeMWhAck = modPreviousFjärrVärme?.data[nameof<IModuleVärmePrimärFjärr>("mätvärdeMWh")] ?? 0;

      const BIM_MedelAvkylning_FJV_SWE = bimHandler.BIM_MedelAvkylning_FJV_SWE;
      const BFV_J10_Faktor_Värme_Kapacitet_Och_Densitet = globalData.System.mapSystemParametrar.BFV_J10_Faktor_Värme_Kapacitet_Och_Densitet;

      //Pre calculation required
      const B40_Mätdata_fjärrvärmemätare = moduleData.saknarMätvärde;

      //Config
      //const B35_Avgift_bonus = moduleData.flödestaxa; //todo: ska hämta schablon ifall valt av användare
      //B35 : =IF(OR(flödestaxa='Grunddata IN'!CH10;flödestaxa="");BIM_FlödesTaxa_Kr_m3;flödestaxa)
      const B35_Avgift_bonus = moduleData.användSchablon ? globalData.System.mapSystemParametrar.BIM_FlödesTaxa_Kr_m3 : moduleData.flödestaxa;
      const B37_Tillämpar_flödestaxa = moduleData.harFlödestaxa;

      //Round
      const B34_Byggnadens_årliga_fjärrvärmeanvändning = byggnadsDataData?.energikälla === "Fjärrvärme" ? byggnadsDataData.årligVärmeFörbrukning / 1000 : 0;
      const B38_Returtemperaturer_Sekundärsida = (moduleData.returTempPrimär ? moduleData.returTempPrimär : 0) - (moduleData.returTempSekunär ? moduleData.returTempSekunär : 0);
      const B39_Tillopp_returtemperatur_Sekundärsida = (moduleData.tilloppstempSekundär ? moduleData.tilloppstempSekundär : 0) - (moduleData.returTempSekunär ? moduleData.returTempSekunär : 0);
      const B41_Temperatur_utegivare = moduleData.temperaturUtegivare;

      //Beräkning
      const B31_Riktvärde_avkylning = BIM_MedelAvkylning_FJV_SWE;
      //const B32_Aktuell_avkylning = 0; //not used?
      const B33_Faktor_Värme_KapacitetDensitet = BFV_J10_Faktor_Värme_Kapacitet_Och_Densitet;
      const deltaRow = globalData.BFV_J10.tempTillDeltaT.find((r) => r.Utetemp === moduleData.temperaturUtegivare);
      const deltaT = deltaRow ? deltaRow.DeltaT : 0;
      const B43_Gränsvärde_sekundärsida_Ok = 0.75; //todo: Är den alltid 75%
      const B42_Gränsvärde_sekundärsida_funktionskontroll = deltaT * B43_Gränsvärde_sekundärsida_Ok;

      //Gröna celler
      //const D24_Anläggningens_QWTal = B40_Mätdata_fjärrvärmemätare === "Nej" ? (mätvärdeM3 - mätvärdeM3Ack) / (mätvärdeMWh - mätvärdeMWhAck) : 0;
      const D24_Anläggningens_QWTal = B40_Mätdata_fjärrvärmemätare === "Nej" ? (mätvärdeM3 || 0) / (mätvärdeMWh || 1) : 0;

      const D25_Riktvärde_QWTal = 1 / (BIM_MedelAvkylning_FJV_SWE / BFV_J10_Faktor_Värme_Kapacitet_Och_Densitet); //todo: bimHandler? G43 1/(BIM_MedelAvkylning_FJV_SWE/880) Är 880 BFV_J10_Faktor_Värme_Kapacitet_Och_Densitet

      const B36_Straffavgift_bonus_avkylning =
        B37_Tillämpar_flödestaxa === "Ja" && B40_Mätdata_fjärrvärmemätare !== "Ja"
          ? (D24_Anläggningens_QWTal - D25_Riktvärde_QWTal) * (B35_Avgift_bonus ?? 0) * B34_Byggnadens_årliga_fjärrvärmeanvändning
          : 0;

      dbg["Tabell 1 "] = {
        "1. Riktvärde avkylning, ingen avgift & ingen bonus (°C)": B31_Riktvärde_avkylning,
        //B32_Aktuell_avkylning,
        "3. Faktor för värme- kapacitet och densitet": B33_Faktor_Värme_KapacitetDensitet,
        "4. Byggnadens årliga fjärrvärmeanvändning (MWh)": B34_Byggnadens_årliga_fjärrvärmeanvändning,
        "5. Avgift eller bonus (kronor per m³ )": B35_Avgift_bonus,
        "6. Straffavgift eller bonus för avkylning (Kr/år)": B36_Straffavgift_bonus_avkylning,
        "7. Tillämpar fjärrvärmeleverantören flödestaxa (Ja/Nej)": B37_Tillämpar_flödestaxa,
        "8. △t Returtemperaturer FJV - Sekundärsida": B38_Returtemperaturer_Sekundärsida,
        "9. △t Tillopp & returtemperatur sekundärsida": B39_Tillopp_returtemperatur_Sekundärsida,
        "10. Mätdata från fjärrvärmemätare saknas": B40_Mätdata_fjärrvärmemätare,
        "11. Temperatur utegivare °C": B41_Temperatur_utegivare,
        "12. Gränsvärde △t sekundärsida funktionskontroll OK.": B42_Gränsvärde_sekundärsida_funktionskontroll,
        "13. Gränsvärde △t sekundärsida OK (%).": B43_Gränsvärde_sekundärsida_Ok,
      };
      dbg["QW-tal "] = {
        "Anläggningens QW- tal (m³ ➗ MWh) - Se vägledning": D24_Anläggningens_QWTal,
        "Riktvärde QW- tal.  Ett högt QW- tal kan innebära flödesavgift och ett lågt QW- tal flödespremie från energibolaget.": D25_Riktvärde_QWTal,
      };

      if (B37_Tillämpar_flödestaxa === "Ja") {
        //Rule 7:
        // funktionsKontroller = [
        //   {
        //     index: 7,
        //     message: "",
        //   },
        // ];

        //Rule 6:
        // A8 : =IF(AND(B37="Ja";B40=1);1;0)
        const A8_FjärrvärmemätareSaknas = B40_Mätdata_fjärrvärmemätare === "Ja";
        if (A8_FjärrvärmemätareSaknas) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 6,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText6.Text, //"Mätdata från fjärrvärmemätare saknas. Funktionskontroll av flödestaxa för fjärrvärmeväxlare har inte kunnat utföras.",

          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 6, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 5:
        // A8 : =IF(AND(B37="Ja";B40=0;B36>0;B38<3;B39>B42);1;0)
        const A7_FelaktigaVärden =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          B36_Straffavgift_bonus_avkylning > 0 &&
          B38_Returtemperaturer_Sekundärsida < 3 &&
          B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll;

        if (A7_FelaktigaVärden) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 5,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText5.Text, //"Mätvärde har kontrollerats. Resultat indikerar på att värden för uppmätta temperaturer på primär och sekundärsida kan vara felaktiga. Alternativt så är värmemängdsmätarens avlästa mätvärden felaktiga. Besparingspotential i kr/år för minskad kostnad flödestaxa om mätvärden värmemängdsmätare är rätt.",
          //     sek: B36_Straffavgift_bonus_avkylning,
          //   },
          // ];
          funktionsKontrollerSEK = [roundHandler.getFunktionsKontrollSEK(bfName, 5, B36_Straffavgift_bonus_avkylning)];
        }

        //Rule 4:
        // A8 : =IF(AND(B37="Ja";B40=0;B36>0;B38>3;B39<B42);1;0)
        const A6_FörsämradFunktionAvkylningEllerFjärrvärmeväxlareFörsmutsad =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          B36_Straffavgift_bonus_avkylning > 0 &&
          B38_Returtemperaturer_Sekundärsida > 3 &&
          B39_Tillopp_returtemperatur_Sekundärsida < B42_Gränsvärde_sekundärsida_funktionskontroll;
        if (A6_FörsämradFunktionAvkylningEllerFjärrvärmeväxlareFörsmutsad) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 4,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText4.Text, //"Mätvärden har kontrollerats. Resultatet visar på att värmesystemet kan ha försämrad funktion med avseende på avkylning och att fjärrvärmeväxlare kan vara försmutsad. Besparingspotential i kr/år för minskad kostnad flödestaxa.",
          //     sek: B36_Straffavgift_bonus_avkylning,
          //   },
          // ];

          funktionsKontrollerSEK = [roundHandler.getFunktionsKontrollSEK(bfName, 4, B36_Straffavgift_bonus_avkylning)];
        }

        //Rule 3:
        // A8 : =IF(AND(B36>0;B39<B42;B38<3);1;0)
        const A5_FörsämradFunktionAvkylning =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          B36_Straffavgift_bonus_avkylning > 0 &&
          B39_Tillopp_returtemperatur_Sekundärsida < B42_Gränsvärde_sekundärsida_funktionskontroll &&
          B38_Returtemperaturer_Sekundärsida < 3;
        if (A5_FörsämradFunktionAvkylning) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 3,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText3.Text, // "Mätvärden har kontrollerats. Resultatet visar på att värmesystemet kan ha försämrad funktion med avseende på avkylning. Besparingspotential i kr/år för minskad kostnad flödestaxa.",
          //     sek: B36_Straffavgift_bonus_avkylning,
          //   },
          // ];

          funktionsKontrollerSEK = [roundHandler.getFunktionsKontrollSEK(bfName, 3, B36_Straffavgift_bonus_avkylning)];
        }

        //Rule 2:
        // A8 : =IF(AND(B37="Ja";B40=0;B36>0;B38>3;B39>B42);1;0)
        const A4_FjärrvärmeväxlareFörsmutsad =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          B36_Straffavgift_bonus_avkylning > 0 &&
          B38_Returtemperaturer_Sekundärsida > 3 &&
          B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll;
        if (A4_FjärrvärmeväxlareFörsmutsad) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 2,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText2.Text, //"Mätvärden har kontrollerats. Resultatet visar på att fjärrvärmeväxlare kan vara försmutsad. Besparingspotential i kr/år för minskad kostnad flödestaxa.",
          //     sek: B36_Straffavgift_bonus_avkylning,
          //   },
          // ];
          funktionsKontrollerSEK = [roundHandler.getFunktionsKontrollSEK(bfName, 2, B36_Straffavgift_bonus_avkylning)];
        }

        //Rule 1:
        // A8 : =IF(AND(B37="Ja";B40=0;B36<0,1);1;0)
        const A3_GodFunktionalitet = B40_Mätdata_fjärrvärmemätare !== "Ja" && B36_Straffavgift_bonus_avkylning < 0.1;
        if (A3_GodFunktionalitet) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 1,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText1.Text, //"Mätvärden har kontrollerats. Resultatet visar på att värmesystem och fjärrvärmeväxlare har god funktionalitet med avseende på avkylning.",
          //     sek: undefined,
          //   },
          // ];

          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 1, undefined, "")];
          funktionsKontrollerSEK = [];
        }
      } else {
        //else -> B37_Tillämpar_flödestaxa === "Nej"
        //Rule 6:
        // B19 : =IF(B40=1;"Ja";"Nej")
        const B19 = B40_Mätdata_fjärrvärmemätare === "Ja";
        if (B19) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 13,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText13.Text, //"Mätdata från fjärrvärmemätare saknas. Funktionskontroll avkylning för fjärrvärmeväxlare har inte kunnat utföras.",
          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 13, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 5:
        // B18 : =IF(AND(B40=0;D24>'Grunddata BIM'!G43;B38<3;B39>B42);"Ja";"Nej")
        // const B18 =
        //   B40_Mätdata_fjärrvärmemätare !== "Ja" &&
        //   D24_Anläggningens_QWTal > D25_Riktvärde_QWTal &&
        //   B38_Returtemperaturer_Sekundärsida < 3 &&
        //   B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll;

        //const j10_D31HögtQWTal = IF(AND(BFV_J10_B40=0;D24>'Grunddata BIM'!G43);1;0)
        const j10_D31HögtQWTal = B40_Mätdata_fjärrvärmemätare !== "Ja" && D24_Anläggningens_QWTal > D25_Riktvärde_QWTal;
        //const j10_D32_BraÖverföring =IF(AND(BFV_J10_B38<3;BFV_J10_B39>BFV_J10_B42);1;0)
        const j10_D32_BraÖverföring = B38_Returtemperaturer_Sekundärsida < 3 && B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll;
        //const j10_D34_LågtQWTal=IF(AND(BFV_J10_B40=0;D24<'Grunddata BIM'!G43);1;0)
        const j10_D34_LågtQWTal = B40_Mätdata_fjärrvärmemätare !== "Ja" && D24_Anläggningens_QWTal < D25_Riktvärde_QWTal;
        //const j10_D35_DåligÖverföring=IF(OR(BFV_J10_B38>3;BFV_J10_B39<BFV_J10_B42);1;0)
        const j10_D35_DåligÖverföring = B38_Returtemperaturer_Sekundärsida > 3 || B39_Tillopp_returtemperatur_Sekundärsida < B42_Gränsvärde_sekundärsida_funktionskontroll;
        //j10_D37_VillkorB18=IF(OR(D31+D32=2;D34+D35=2);1;0)
        const j10_D37_VillkorB18 = (j10_D31HögtQWTal && j10_D32_BraÖverföring) || (j10_D34_LågtQWTal && j10_D35_DåligÖverföring);
        const B18 = B40_Mätdata_fjärrvärmemätare !== "Ja" && j10_D37_VillkorB18;
        if (B18) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 12,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText12.Text, //"Mätvärde har kontrollerats. Resultat indikerar på att värden för uppmätta temperaturer på primär och sekundärsida kan vara felaktiga. Alternativt så är värmemängdsmätarens avlästa mätvärden felaktiga.",
          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 12, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 4:
        // B17 : =IF(AND(D24>D25;B38>3;B39<B42);"Ja";"Nej")
        const B17 =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          D24_Anläggningens_QWTal > D25_Riktvärde_QWTal &&
          B38_Returtemperaturer_Sekundärsida > 3 &&
          B39_Tillopp_returtemperatur_Sekundärsida < B42_Gränsvärde_sekundärsida_funktionskontroll;
        if (B17) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 11,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText11.Text, //"Mätvärden har kontrollerats. Resultatet visar på att värmesystemet kan ha försämrad funktion med avseende på avkylning och fjärrvärmeväxlare kan vara försmutsad.",
          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 11, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 3:
        // B16 : =IF(AND(D24>'Grunddata BIM'!G43;B38<3;B39<B42);"Ja";"Nej")
        const B16 =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          D24_Anläggningens_QWTal > D25_Riktvärde_QWTal &&
          B38_Returtemperaturer_Sekundärsida < 3 &&
          B39_Tillopp_returtemperatur_Sekundärsida < B42_Gränsvärde_sekundärsida_funktionskontroll;
        if (B16) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 10,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText10.Text, //"Mätvärden har kontrollerats. Resultatet visar på att värmesystemet kan ha försämrad funktion med avseende på avkylning.",
          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 10, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 2:
        // B15 : =IF(AND(D24<D25;B39>B42;B38>3);"Ja";"Nej")
        //const B15 =IF(AND(BFV_J10_B40=0;D24>D25;BFV_J10_B39>BFV_J10_B42;BFV_J10_B38>3);"Ja";"Nej")
        const B15 =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          D24_Anläggningens_QWTal > D25_Riktvärde_QWTal &&
          B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll &&
          B38_Returtemperaturer_Sekundärsida > 3;

        if (B15) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 9,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText9.Text, //"Mätvärden har kontrollerats. Resultatet visar på att fjärrvärmeväxlare kan vara försmutsad.",
          //     sek: undefined,
          //   },

          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 9, undefined, "")];
          funktionsKontrollerSEK = [];
        }

        //Rule 1:
        // B14 : =IF(AND(B37="Nej";D24<D25;B39>B42;B38<3);"Ja";"Nej")

        //const tstB14 = IF(AND(BFV_J10_B40=0;BFV_J10_B37="Nej";D24<D25;BFV_J10_B39>BFV_J10_B42;BFV_J10_B38<3);"Ja";"Nej")
        const B14 =
          B40_Mätdata_fjärrvärmemätare !== "Ja" &&
          B37_Tillämpar_flödestaxa === "Nej" &&
          D24_Anläggningens_QWTal < D25_Riktvärde_QWTal &&
          B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll &&
          B38_Returtemperaturer_Sekundärsida < 3;
        // const B14 =
        //   B40_Mätdata_fjärrvärmemätare !== "Ja" &&
        //   D24_Anläggningens_QWTal < D25_Riktvärde_QWTal &&
        //   B39_Tillopp_returtemperatur_Sekundärsida > B42_Gränsvärde_sekundärsida_funktionskontroll &&
        //   B38_Returtemperaturer_Sekundärsida < 3;
        if (B14) {
          // funktionsKontrollerSEK = [
          //   {
          //     index: 8,
          //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ10_FKText8.Text, //"Mätvärden har kontrollerats. Resultatet visar på att värmesystem och fjärrvärmeväxlare har god funktionalitet med avseende på avkylning.",
          //     sek: undefined,
          //   },
          // ];
          funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 8, undefined, "")];
          funktionsKontrollerSEK = [];
        }
      }

      // funktionsKontrollerSEK = [
      //   {
      //     index: 5, //todo ! Remove
      //     message: "Testing ", //"Mätvärde har kontrollerats. Resultat indikerar på att värden för uppmätta temperaturer på primär och sekundärsida kan vara felaktiga. Alternativt så är värmemängdsmätarens avlästa mätvärden felaktiga. Besparingspotential i kr/år för minskad kostnad flödestaxa om mätvärden värmemängdsmätare är rätt.",
      //     sek: 99.98,
      //   },
      // ];

      return {
        bfName: BFLType.BFV_J10,
        funktionsKontrollerSEK: funktionsKontrollerSEK,
        funktionsKontroller: funktionsKontroller,
        driftOptimeringar: [],
        note: "",
        debug: dbg,
        data: {
          export: {
            Anläggningens_QWTal: D24_Anläggningens_QWTal,
            Riktvärde_QWTal: D25_Riktvärde_QWTal,
          },
        },
      };
    } catch (ex: any) {
      logAndNotifyError(ex);
      return {
        bfName: BFLType.BFV_J13,
        funktionsKontroller: funktionsKontroller,
        funktionsKontrollerSEK: funktionsKontrollerSEK,
        note: "",
        error: ex,
        debug: dbg,
        driftOptimeringar: [],
      };
    }
  };

  return { getResult, bfName };
};

const dflt = { bfv_J10 };

export default dflt;
